module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-9-we-003.c4831bce.json").toString();